<template>
  <div class="create-comment">
    <template v-if="!commentForm.loading">
      <div class="form">
        <figure v-if="globals.userInfo && globals.userInfo.avatarObject">
          <img :src="globals.userInfo.avatarObject.thumb.location" />
        </figure>
        <textarea
          :placeholder="$t('Write a comment') + '...'"
          v-model="commentForm.text"
          name="text"
          @input="onSetTextareaHeight"
          :class="{ 'mobile-field': isMobile() }"
        ></textarea>
        <div class="buttons">
          <span
            class="blue-button font-size-s bordered grayed"
            :class="{ gray: !commentForm.text.trim().length }"
            @click="closeCreateCommentForm()"
          >
            {{ $t("Cancel") }}
          </span>
          <span
            class="blue-button font-size-s"
            :class="{ gray: !commentForm.text.trim().length }"
            @click="onPostComment"
          >
            {{ $t("Post") }}
          </span>
        </div>
      </div>
    </template>
    <div v-if="commentForm.loading">
      <em>{{ $t("Please wait") }}...</em>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "CreateCommentForm",
  data() {
    return {
      commentForm: {
        text: "",
        loading: false,
      },
    };
  },
  props: ["debate"],
  inject: [
    "globals",
    "isMobile",
    "fireEvent",
    "stopReply",
    "loadDebate",
    "replyArgumentId",
    "replyCommentId",
    "refreshAuthToken",
  ],
  methods: {
    closeCreateCommentForm() {
      this.stopReply();
    },
    onPostComment() {
      this.commentForm.loading = true;

      axios
        .post("/comment/create", {
          comment: this.commentForm.text,
          argumentId: this.replyArgumentId,
          domain: this.debate.siteDomain,
          pageUrl: window.location.href,
        })
        .then(
          () => {
            this.fireEvent({
              debateId: this.debate.id,
              sideId: this.debate.votedSideId ? this.debate.votedSideId : 0,
              userId: this.globals.userKey,
              fingerprintId: this.globals.deviceId,
              eventType: "comment",
            });

            this.commentForm = { text: "", loading: false };
            this.loadDebate(null, true);
            this.stopReply();
          },
          ({ response }) => {
            if (response.status === 401) {
              this.refreshAuthToken(() => this.onPostComment(), true);
            } else {
              this.commentForm.loading = false;
              alert(Object.values(response.data.message[0])[0]);
            }
          },
        );
    },
  },
};
</script>
